/**
 *
 * Asynchronously loads the component for OAuthForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OAuthForm = lazyLoad(
  () => import('./index'),
  module => module.OAuthForm,
);
